import {
    Box,
    Card,
    Chip,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { AccessTime, CheckCircle, Close, EventNote, Schedule } from "@material-ui/icons"
import { useSnackbar } from "../../../utils/notificacoes"
import React, { useEffect, useState } from "react"
import {
    aceitarPedidoAgendado,
    buscarConfiguracoesAgendamento,
    buscarPedidosAgendados,
    cancelarPedidoAgendado,
    finalizarPedidoAgendado,
} from "../../../services/apiAgendamento"
import { buscarInformacoesPedido } from "../../../services/integracao"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import Cabecalho from "../../Cabecalho"
import { Loading } from "../../RegistradorDePedidos"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
        [theme.breakpoints.down("xs")]: {
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "60px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "1400px",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
        },
    },
    header: {
        marginBottom: theme.spacing(4),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(2),
            marginBottom: theme.spacing(3),
        },
    },
    headerTitle: {
        display: "flex",
        alignItems: "center",
        gap: "1.6rem",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(0.5),
        },
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.25rem",
        },
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem",
        },
    },
    columnsContainer: {
        display: "flex",
        gap: theme.spacing(3),
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            gap: theme.spacing(2),
        },
    },
    column: {
        flex: 1,
        minWidth: 0,
    },
    columnHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderRadius: "20px 20px 0 0",
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
            borderRadius: "15px 15px 0 0",
        },
    },
    columnTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
        },
    },
    columnContent: {
        backgroundColor: "white",
        borderRadius: "0 0 20px 20px",
        padding: theme.spacing(2),
        minHeight: "400px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        [theme.breakpoints.down("sm")]: {
            borderRadius: "0 0 15px 15px",
            minHeight: "300px",
        },
    },
    pedidoCard: {
        border: "2px solid #e9ecef",
        borderRadius: 15,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: "#fafafa",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
            borderColor: "#4caf50",
            backgroundColor: "#f8fff8",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 12px rgba(var(--cor-botao-salvar-rgb), 0.2)",
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1.5),
        },
    },
    pedidoHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(1),
        },
    },
    pedidoId: {
        fontWeight: 600,
        color: "#2c3e50",
        fontSize: "1.1rem",
    },
    pedidoInfo: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    infoRow: {
        display: "flex",
        alignItems: "center",
        color: "#7f8c8d",
        fontSize: "0.9rem",
        "& svg": {
            marginRight: theme.spacing(0.5),
            fontSize: "1rem",
            color: "#4caf50",
        },
    },
    statusChip: {
        borderRadius: 12,
        fontWeight: 500,
    },
    actionButton: {
        marginTop: theme.spacing(1),
        borderRadius: 12,
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        padding: theme.spacing(1, 2),
        fontWeight: 600,
        fontSize: "0.85rem",
        "&:hover": {
            backgroundColor: "var(--cor-botao-salvar-hover)",
        },
    },
    cancelButton: {
        marginTop: theme.spacing(1),
        borderRadius: 12,
        backgroundColor: "var(--cor-erro)",
        color: "white",
        padding: theme.spacing(1, 2),
        fontWeight: 600,
        fontSize: "0.85rem",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
        },
    },
    finishButton: {
        marginTop: theme.spacing(1),
        borderRadius: 12,
        backgroundColor: "#2196f3",
        color: "white",
        padding: theme.spacing(1, 2),
        fontWeight: 600,
        fontSize: "0.85rem",
        "&:hover": {
            backgroundColor: "#1976d2",
        },
    },
    buttonGroup: {
        display: "flex",
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    emptyState: {
        textAlign: "center",
        padding: theme.spacing(4),
        color: "#95a5a6",
        fontStyle: "italic",
    },
    dialogPaper: {
        borderRadius: 20,
        maxWidth: "600px",
        [theme.breakpoints.down("sm")]: {
            borderRadius: 15,
            margin: theme.spacing(2),
        },
    },
    dialogHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(3),
        borderBottom: "2px solid #e9ecef",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    dialogTitle: {
        display: "flex",
        alignItems: "center",
        fontWeight: 600,
        color: "#2c3e50",
    },
    dialogContentArea: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
}))

function formatIsoStringIgnoringTZ(isoString) {
    if (typeof isoString !== "string") return ""
    const m = isoString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/)
    if (!m) return ""

    const [, yyyy, mm, dd, hh, min] = m
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`
}
const PedidoCard = ({
    pedido,
    aceitar,
    cancelar,
    finalizar,
    onOpenDialog,
    aceiteAutomatico,
    classes,
}) => {
    const setLoading = useLoadingStore(s => s.setLoading)
    const autorizacao = localStorage.getItem("chaveSistema")
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const handleAceitarClick = e => {
        e.stopPropagation()
        if (pedido.status === 1) {
            aceitar(pedido.idPedido)
        }
    }

    const handleCancelClick = e => {
        e.stopPropagation()
        cancelar(pedido.idPedido)
    }

    const handleFinishClick = e => {
        e.stopPropagation()
        finalizar(pedido.idPedido)
    }

    const handleBuscarPedido = async pedido => {
        setLoading(true)
        try {
            const response = await buscarInformacoesPedido(autorizacao, pedido.idPedido)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                const data = {
                    ...response,
                    dataAgendamento: formatIsoStringIgnoringTZ(pedido.dataInicio),
                }
                onOpenDialog(data)
            }
        } catch (error) {
            alertStart(error, "error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <Card className={classes.pedidoCard} onClick={() => handleBuscarPedido(pedido)}>
            <Box className={classes.pedidoHeader}>
                <Typography className={classes.pedidoId}>Pedido #{pedido.idPedido}</Typography>
                <Chip
                    label={pedido.status === 1 ? 1 : "Em Produção"}
                    className={classes.statusChip}
                    size="small"
                    style={{
                        backgroundColor: pedido.status === 1 ? "#fff3e0" : "#e3f2fd",
                        color: pedido.status === 1 ? "#f57c00" : "#1976d2",
                    }}
                />
            </Box>
            <Box className={classes.pedidoInfo}>
                <Box className={classes.infoRow}>
                    <AccessTime />
                    <Typography variant="body2">
                        Data de entrega: {formatIsoStringIgnoringTZ(pedido.dataEntrega)}
                    </Typography>
                </Box>
            </Box>

            {/* {!aceiteAutomatico && pedido.status === 1 && (
                <Box className={classes.buttonGroup}>
                    <Button
                        className={classes.cancelButton}
                        style={{ flex: 1 }}
                        startIcon={<Cancel />}
                        onClick={handleCancelClick}
                    >
                        Recusar
                    </Button>
                    <Button
                        className={classes.actionButton}
                        style={{ flex: 1 }}
                        startIcon={<ArrowForward />}
                        onClick={handleAceitarClick}
                    >
                        Aceitar
                    </Button>
                </Box>
            )} */}

            {/* {pedido.status === 2 && (
                <Box className={classes.buttonGroup}>
                    <Button
                        className={classes.cancelButton}
                        style={{ flex: 1 }}
                        startIcon={<Cancel />}
                        onClick={handleCancelClick}
                    >
                        Cancelar
                    </Button>
                    <Button
                        className={classes.finishButton}
                        style={{ flex: 1 }}
                        startIcon={<Done />}
                        onClick={handleFinishClick}
                    >
                        Finalizar
                    </Button>
                </Box>
            )} */}
        </Card>
    )
}

export function PedidosAgendados() {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const setLoading = useLoadingStore(s => s.setLoading)
    const autorizacao = localStorage.getItem("chaveSistema")
    const configuracoesEst = useAppStore(s => s.configuracoes)
    const idEstabelecimento = configuracoesEst.user.parametros.estabelecimento.id

    const [aceiteAutomatico, setAceiteAutomatico] = useState(false)

    const [pedidos, setPedidos] = useState([])

    const [openDialog, setOpenDialog] = useState(false)
    const [pedidoSelecionado, setPedidoSelecionado] = useState(null)

    const pedidosPendentes = pedidos?.filter(p => p.status === 1)
    const pedidosProducao = pedidos?.filter(p => p.status === 2)

    const handleOpenDialog = pedido => {
        setPedidoSelecionado(pedido)
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
        setPedidoSelecionado(null)
    }

    const handleAceitarPedido = async idPedido => {
        setLoading(true)
        const data = {
            idPedido,
        }
        try {
            const response = await aceitarPedidoAgendado(data, idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPedidos(prev =>
                    prev.map(p => (p.idPedido === idPedido ? { ...p, status: 2 } : p))
                )
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleCancelarPedido = async idPedido => {
        setLoading(true)
        const data = {
            idPedido,
        }
        try {
            const response = await cancelarPedidoAgendado(data, idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPedidos(prev => prev.filter(p => p.idPedido !== idPedido))
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleFinalizarPedido = async idPedido => {
        setLoading(true)
        const data = {
            idPedido,
        }
        try {
            const response = await finalizarPedidoAgendado(data, idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPedidos(prev => prev.filter(p => p.idPedido !== idPedido))
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleBuscarConfiguracoesAgendamento = async () => {
        setLoading(true)
        try {
            const response = await buscarConfiguracoesAgendamento(idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setAceiteAutomatico(response.aceiteAutomatico)
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleBuscarPedidosAgendados = async () => {
        setLoading(true)
        try {
            const response = await buscarPedidosAgendados(idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPedidos(response)
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        handleBuscarConfiguracoesAgendamento()
        handleBuscarPedidosAgendados()
    }, [])

    return (
        <>
            <Loading />
            <Cabecalho pagina={"Pedidos Agendados"} />
            <div className={classes.container}>
                <div className={classes.content}>
                    <Box className={classes.header}>
                        <Box className={classes.headerTitle}>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" className={classes.titleText}>
                                    Pedidos Agendados
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" style={{ color: "#7f8c8d" }}>
                                Gerencie os pedidos agendados do seu estabelecimento
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={classes.columnsContainer}>
                        {!aceiteAutomatico ? (
                            <>
                                <Box className={classes.column}>
                                    <Box className={classes.columnHeader}>
                                        <Typography variant="h6" className={classes.columnTitle}>
                                            <Schedule
                                                style={{ marginRight: 8, color: "#f57c00" }}
                                            />
                                            Pendentes
                                        </Typography>
                                        <Chip
                                            label={pedidosPendentes.length}
                                            size="small"
                                            style={{
                                                backgroundColor: "#fff3e0",
                                                color: "#f57c00",
                                                fontWeight: 600,
                                            }}
                                        />
                                    </Box>
                                    <Box className={classes.columnContent}>
                                        {pedidosPendentes.length > 0 ? (
                                            pedidosPendentes.map(pedido => (
                                                <PedidoCard
                                                    key={pedido.id}
                                                    pedido={pedido}
                                                    aceitar={handleAceitarPedido}
                                                    cancelar={handleCancelarPedido}
                                                    finalizar={handleFinalizarPedido}
                                                    onOpenDialog={handleOpenDialog}
                                                    aceiteAutomatico={aceiteAutomatico}
                                                    classes={classes}
                                                    autorizacao={autorizacao}
                                                />
                                            ))
                                        ) : (
                                            <Box className={classes.emptyState}>
                                                <Schedule
                                                    style={{
                                                        fontSize: 48,
                                                        color: "#bdc3c7",
                                                        marginBottom: 16,
                                                    }}
                                                />
                                                <Typography variant="body1">
                                                    Nenhum pedido pendente
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>

                                <Box className={classes.column}>
                                    <Box className={classes.columnHeader}>
                                        <Typography variant="h6" className={classes.columnTitle}>
                                            <CheckCircle
                                                style={{ marginRight: 8, color: "#1976d2" }}
                                            />
                                            Em Produção
                                        </Typography>
                                        <Chip
                                            label={pedidosProducao.length}
                                            size="small"
                                            style={{
                                                backgroundColor: "#e3f2fd",
                                                color: "#1976d2",
                                                fontWeight: 600,
                                            }}
                                        />
                                    </Box>
                                    <Box className={classes.columnContent}>
                                        {pedidosProducao.length > 0 ? (
                                            pedidosProducao.map(pedido => (
                                                <PedidoCard
                                                    key={pedido.id}
                                                    pedido={pedido}
                                                    aceitar={handleAceitarPedido}
                                                    cancelar={handleCancelarPedido}
                                                    finalizar={handleFinalizarPedido}
                                                    onOpenDialog={handleOpenDialog}
                                                    aceiteAutomatico={aceiteAutomatico}
                                                    classes={classes}
                                                />
                                            ))
                                        ) : (
                                            <Box className={classes.emptyState}>
                                                <CheckCircle
                                                    style={{
                                                        fontSize: 48,
                                                        color: "#bdc3c7",
                                                        marginBottom: 16,
                                                    }}
                                                />
                                                <Typography variant="body1">
                                                    Nenhum pedido em produção
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </>
                        ) : (
                            <Box className={classes.column}>
                                <Box className={classes.columnHeader}>
                                    <Typography variant="h6" className={classes.columnTitle}>
                                        <CheckCircle style={{ marginRight: 8, color: "#4caf50" }} />
                                        Pedidos Aceitos
                                    </Typography>
                                    <Chip
                                        label={pedidos.length}
                                        size="small"
                                        style={{
                                            backgroundColor: "#e8f5e9",
                                            color: "#4caf50",
                                            fontWeight: 600,
                                        }}
                                    />
                                </Box>
                                <Box className={classes.columnContent}>
                                    {pedidos.length > 0 ? (
                                        pedidos.map(pedido => (
                                            <PedidoCard
                                                key={pedido.id}
                                                pedido={pedido}
                                                aceitar={handleAceitarPedido}
                                                cancelar={handleCancelarPedido}
                                                finalizar={handleFinalizarPedido}
                                                onOpenDialog={handleOpenDialog}
                                                aceiteAutomatico={aceiteAutomatico}
                                                classes={classes}
                                            />
                                        ))
                                    ) : (
                                        <Box className={classes.emptyState}>
                                            <CheckCircle
                                                style={{
                                                    fontSize: 48,
                                                    color: "#bdc3c7",
                                                    marginBottom: 16,
                                                }}
                                            />
                                            <Typography variant="body1">
                                                Nenhum pedido agendado
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        )}
                    </Box>

                    <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ className: classes.dialogPaper }}
                    >
                        <Box className={classes.dialogHeader}>
                            <Typography variant="h6" className={classes.dialogTitle}>
                                <EventNote style={{ marginRight: 8, color: "#4caf50" }} />
                                Detalhes do Pedido {pedidoSelecionado?.id}
                            </Typography>
                            <IconButton size="small" onClick={handleCloseDialog}>
                                <Close />
                            </IconButton>
                        </Box>
                        <DialogContent className={classes.dialogContentArea}>
                            <Typography style={{ marginBottom: "2rem", fontWeight: "bold" }}>
                                Data de entrega: {pedidoSelecionado?.dataAgendamento}
                            </Typography>
                            <Typography
                                variant="body1"
                                style={{
                                    lineHeight: 1.8,
                                    whiteSpace: "pre-line",
                                    marginTop: "-7rem",
                                }}
                            >
                                {pedidoSelecionado?.texto}
                            </Typography>
                        </DialogContent>
                    </Dialog>
                </div>
            </div>
        </>
    )
}
